export const QUIPA_ASSISTANT_OPEN_EVENT = 'quipa-assistant:open';
export const QUIPA_ASSISTANT_CLOSED_EVENT = 'quipa-assistant:closed';
export const QUIPA_ASSISTANT_CREATE_PROJECT_GATE = 'quipa_assistant_create_project';
export const QUIPA_ASSISTANT_FEEDBACK_GATE = 'quipa_assistant_feedback';

export type QuipaAssistantContext = Record<string, unknown>;

export interface QuipaAssistantOpenDetail {
  context?: QuipaAssistantContext;
}

export interface QuipaAssistantClosedDetail {
  context?: QuipaAssistantContext;
}

export const openQuipaAssistant = (context: QuipaAssistantContext = {}): void => {
  if (typeof window === 'undefined') return;

  const referrer = `${window.location.pathname}${window.location.search}`;
  const withContext = { referrer, ...context };

  window.dispatchEvent(
    new CustomEvent<QuipaAssistantOpenDetail>(QUIPA_ASSISTANT_OPEN_EVENT, {
      detail: { context: withContext },
    })
  );
};

export const dispatchQuipaAssistantClosed = (context: QuipaAssistantContext = {}): void => {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(
    new CustomEvent<QuipaAssistantClosedDetail>(QUIPA_ASSISTANT_CLOSED_EVENT, {
      detail: { context },
    })
  );
};
